import { Box, Card, Tab } from "@mui/material";
import PageContainer from "../../../components/container/PageContainer";

import Breadcrumb from "../../../layouts/full-layout/breadcrumb/Breadcrumb";

import RequestTypeMaster from "./RequestTypeMaster";

const RequestTypeManagement = () => {
  const BCrumb = [
    { to: "/", title: "Admin" },

    { title: "Request Type Management" },
  ];

  return (
    <PageContainer title="Request Type Management">
      <Breadcrumb
        title="Request Type Management"
        items={BCrumb}
      />
<Card>
    
      <RequestTypeMaster />
</Card>
    </PageContainer>
  );
};

export default RequestTypeManagement;